import { render, staticRenderFns } from "./AssociationHistoryLink.vue?vue&type=template&id=a68fdd5a"
import script from "./AssociationHistoryLink.vue?vue&type=script&lang=js"
export * from "./AssociationHistoryLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports